import { CommonModule } from '@angular/common';
import { Component, HostListener, inject, input } from '@angular/core';
import { CnetNgxUiModule } from '@cnet/ngx-ui';
import { TranslateModule } from '@ngx-translate/core';
import { NgxPermissionsModule } from 'ngx-permissions';
import { SubHeaderDetails } from 'src/app/core/models/sub-header-details';
import { StartupService } from 'src/app/core/services/startup.service';
import { FiscalCodePipe } from 'src/app/shared/pipes/fiscal-code-pipe/fiscal-code.pipe';
import { FormatAddressPipe } from 'src/app/shared/pipes/format-address.pipe';
import { PermissionRoleIdTranslatePipe } from 'src/app/shared/pipes/permission-role/permission-role.pipe';

@Component({
  selector: 'app-sub-header-content, [app-sub-header-content], [CnetSubHeaderContent]',
  host: { class: 'app-sub-header-content' },
  exportAs: 'CnetSubHeaderContent',
  imports: [CommonModule, CnetNgxUiModule, TranslateModule, PermissionRoleIdTranslatePipe, FormatAddressPipe, FiscalCodePipe, NgxPermissionsModule],
  templateUrl: './sub-header-content.component.html',
  styleUrl: './sub-header-content.component.scss'
})
export class CnetSubHeaderContentComponent {

  details = input<SubHeaderDetails>(null)
  showPhoto = input(false)
  showGroups = input(false)


  isMobile = false;

  startupService = inject(StartupService);
  hasCSMIntegration = this.startupService.hasCSMIntegration

  ngOnInit(): void {
    this.onResize({ target: { innerWidth: window.innerWidth } })
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.isMobile = event.target.innerWidth <= 992;
  }


}
